export default {
    DOSE_UNICA: 1,
    USO_CONTINUO: 2,
    LIVRE: 3,
}